import { readGroupFromStore } from '../group-store'

function groupIsDefault(groupId) {
  const group = readGroupFromStore(groupId)
  return !!group?.default
}

export { groupIsDefault }